"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.MyHRCaseRedirect = exports.MYHR_CASE_REDIRECT_LINK = void 0;
const react_1 = __importDefault(require("react"));
const react_i18next_1 = require("react-i18next");
const Link_1 = require("@amzn/atoz-web/Link");
const Text_1 = require("@amzn/atoz-web/Text");
const contexts_1 = require("../../../../contexts");
const fetchUtils_1 = require("../../../../client/fetchUtils");
exports.MYHR_CASE_REDIRECT_LINK = 'myhr_case_redirect_link';
const MyHRCaseRedirect = ({ caseId }) => {
    const { currentStage } = (0, contexts_1.useTaaConfigsContext)();
    return (react_1.default.createElement(Text_1.Text, null,
        react_1.default.createElement(react_i18next_1.Trans, { i18nKey: "my_Hr_case_redirect_link_for_report_travel_time", components: {
                caseRedirect: (react_1.default.createElement(Link_1.Link, { "data-test-id": exports.MYHR_CASE_REDIRECT_LINK, href: fetchUtils_1.essPortalUrl[currentStage] +
                        `/myhr/caseList/caseDetailDesktop/MyHRPanoramaCTK01/${caseId}`, textDecoration: "none" }))
            } })));
};
exports.MyHRCaseRedirect = MyHRCaseRedirect;
